// F1 App-Shell (TES-948): kleine Badge-Darstellung fuer Nav-Counts.
// Geteilt von SideNavItem (collapsed-Dot + expanded-Badge) und BottomNav.
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import type { NavBadgeInfo } from "./navBadges";

// Eckiger Dot (collapsed Sidebar / BottomNav-Icon-Ecke)
export function NavBadgeDot({ badge, className }: { badge: NavBadgeInfo; className?: string }) {
  if (!badge.showBadge) return null;
  return (
    <span
      className={cn(
        "absolute h-4 min-w-4 px-1 rounded-full text-[10px] font-bold flex items-center justify-center",
        badge.badgeColor,
        badge.shouldPulse && "animate-badge-pulse",
        className,
      )}
    >
      {badge.badgeCount > 9 ? "9+" : badge.badgeCount}
    </span>
  );
}

// Inline-Pille (expanded Sidebar-Zeile)
export function NavBadgePill({ badge, href }: { badge: NavBadgeInfo; href: string }) {
  if (!badge.showBadge) return null;
  return (
    <Badge
      data-testid={`sidebar-badge-${href.replace("/", "")}`}
      variant="secondary"
      className={cn(
        "text-xs h-5 min-w-[20px] flex items-center justify-center",
        badge.badgeColor,
        badge.shouldPulse && "animate-badge-pulse",
      )}
    >
      {badge.badgeCount}
    </Badge>
  );
}
